/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcFundingV1BatchAllocationState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_FUNDING_V1_BATCH_ALLOCATION_STATE_ENTITY_NAME = 'ixc.funding.v1.BatchAllocation';
export const ixcFundingV1BatchAllocationStateEntity = new schema.Entity<IxcFundingV1BatchAllocationState>(IXC_FUNDING_V1_BATCH_ALLOCATION_STATE_ENTITY_NAME, {}, { idAttribute: 'batchAllocationId' });

